import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import colors from '@/common/colors';

const balanceCheckerStyles = makeStyles(() => createStyles({
  giftCardContent: {
    display: 'flex',
    flexDirection: 'column'
  },
  giftCardFieldsContainer: {
    marginTop: '12px',
    width: '100%'
  },
  giftCardApplyButton: {
    marginTop: '25px',
    '& button': {
      width: '330px'
    }
  },
  giftCardInputContainer: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '330px',
    marginBottom: '20px'
  },
  giftCardError: {
    color: colors.red
  }
}));

export default balanceCheckerStyles;
